import { Droppable } from "@hello-pangea/dnd";

import type { Prospect } from "../types";
import { ProspectCard } from "./ProspectCard";

export const ProspectColumn = ({
  stage,
  label,
  prospects,
}: {
  stage: string;
  label: string;
  prospects: Prospect[];
}) => (
  <div className="flex-1 min-w-56 pb-8">
    <div className="flex flex-col items-center">
      <h3 className="text-base font-medium">{label}</h3>
      <p className="text-sm text-muted-foreground">{prospects.length}</p>
    </div>
    <Droppable droppableId={stage}>
      {(droppableProvided, snapshot) => (
        <div
          ref={droppableProvided.innerRef}
          {...droppableProvided.droppableProps}
          className={`flex flex-col rounded-2xl mt-2 gap-2 p-1 min-h-12 ${
            snapshot.isDraggingOver ? "bg-muted" : ""
          }`}
        >
          {prospects.map((prospect, index) => (
            <ProspectCard key={prospect.id} prospect={prospect} index={index} />
          ))}
          {droppableProvided.placeholder}
        </div>
      )}
    </Droppable>
  </div>
);
